// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PKhD8","type":"styles_type__3SZfu","choices":"styles_choices__1ehUw"};